export function downloadFile(data: File | Blob | MediaSource, fileName: string): void {
  const link = document.createElement('a');
  const href = URL.createObjectURL(data);

  link.setAttribute('download', fileName);
  link.href = href;
  link.setAttribute('target', '_blank');
  link.click();

  URL.revokeObjectURL(href);
}
